export type CampaignBannerId = number

export enum ViewType {
  ALWAYS = 'always',
  ONLY_LOGIN = 'login',
  ONLY_LOGOUT = 'logout',
}

export interface CampaignBanner {
  id: CampaignBannerId
  destUrl: string
  imagePath: string
  imagePathMobile: string
  order: number
  viewType: ViewType
}
